export default __webpack_public_path__ + "static/media/outlook.c25932b2.png";